"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSave = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=save&icon=save&style=baseline
const IconSave = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" })));
};
exports.IconSave = IconSave;
